import styled from 'styled-components'
import { theme } from '../../theme/theme'
import { ChartLegend, stepLegend } from './Legend'
import { SegmentStack } from './SegmentStack'
import { ChartStep } from './type'

type Props = {
  steps: readonly ChartStep[]
  values: Record<string, number>
  /** Unit for the tooltip, e.g. "personer". */
  unit: string
}

export const CompletionBar = ({ steps, values, unit }: Props) => (
  <>
    <SegmentStack steps={steps} values={values} unit={unit} />
    <LegendSpacer>
      <ChartLegend align="start" noLabelFlex data={stepLegend(steps, values)} />
    </LegendSpacer>
  </>
)

const LegendSpacer = styled.div`
  margin-top: ${theme.spacing.small}px;
`
